import algoliasearch from 'algoliasearch/lite'
import algoliasearchHelper from 'algoliasearch-helper'

const ALGOLIA_ID = '6M62U1ZBKU'
const ALGOLIA_KEY = '6698ccede119391b5f6db5c39352b1f2'
const ALGOLIA_INDEX = 'sears'
const ALGOLIA_INDEX_SUGGESTION = 'sears_query_suggestions'

export const TEXTS = Object.freeze({
    ENVIO: 'Envio Gratis',
    EXPRESS: 'Express',
    RANTING: 'Ranting',
    APPID: ALGOLIA_ID,
    APIKEY: ALGOLIA_KEY,
    DESKTOP: 'desktop',
    MOBILE: 'movil',
    EXPRESSPANTALLA: 'mobilePantalla',
    INDEX: ALGOLIA_INDEX,
    SUGGESTION: ALGOLIA_INDEX_SUGGESTION
})

export function cleanText(text){
    const cleanText1 = text.replace(/ /g, '-');
    const cleanText2 = cleanText1.replace(/ñ/g, 'n');
    return cleanText2;
}

export function redondearHaciaAbajo(numero){
    return Math.floor(numero/10)*10
}

export const algoliaClient = algoliasearch(TEXTS.APPID, TEXTS.APIKEY)

export const searchClient = algoliasearch(TEXTS.APPID, TEXTS.APIKEY)

export const indexName = ALGOLIA_INDEX

export const helper = algoliasearchHelper(searchClient, TEXTS.INDEX, {
    analytics: true,
    clickAnalytics: true,
    disjunctiveFacets: ['brand', 'percent_off', 'review_rating', 'has_free_shipping', 'fulfillment', 'sale_price'],
    // enableReRanking: true,
    hierarchicalFacets: [{
        name: 'hirerarchical_category',
        attributes: ['hirerarchical_category.lvl0', 'hirerarchical_category.lvl1', 'hirerarchical_category.lvl2'],
    }]
})